<!-- <div class="filter-div-2 d-flex justify-content-start align-items-center"> -->
<div class="d-flex align-items-center" id="keywordFilterContainer">
    <button [class.active]="showkeywords" class="form-control filter-buttons black-label keyword-filter"
        (click)="showKeywordDiv()" (keyup.enter)="showKeywordDiv()" (keyup.space)="showKeywordDiv()"
        aria-label="keywords">
        <span class="filter-icons">
            <fa-icon class="iconcls" aria-hidden="true" [icon]="['fas', 'table-cells']"></fa-icon>
        </span>
        <span>
            {{'article_listing.keywords' | translate}}
        </span>
    </button>
    <button tabindex="0" role="combobox" aria-haspopup="listbox" aria-expanded="false" aria-controls="sortDropdown"
        aria-label="sort-by" class="form-control filter-buttons black-label keyword-filter" data-bs-toggle="dropdown">
        <span class="filter-icons">
            <fa-icon class="iconcls" aria-hidden="true" [icon]="['fas', 'sort']"></fa-icon>
        </span>
        <span class="sortby">{{'article_listing.sort_by' | translate}}</span>
    </button>

    <div class="dropdown-menu mr-0">
        <button role="listitem" [attr.aria-label]="'article_listing.article_title' |translate"
            class="dropdown-item d-flex justify-content-between align-items-center"
            (click)="toggleSort('article_title',0)" (keyup.enter)="toggleSort('article_title',0)"
            (keyup.space)="toggleSort('article_title',0)" tabindex="0">
            <span class="dropdown-sort-span">{{'article_listing.article_title' |
                translate}}</span>
            <fa-icon aria-hidden="true" class="sort-icons"
                [icon]="['fas', isChevronUp[0] ? 'chevron-up' : 'chevron-down']"></fa-icon>
        </button>
        <button role="listitem" [attr.aria-label]="'article_listing.published_date' |
        translate" class="dropdown-item d-flex justify-content-between align-items-center"
            (click)="toggleSort('pub_date',1)" (keyup.enter)="toggleSort('pub_date',1)"
            (keyup.space)="toggleSort('pub_date',1)" tabindex="0">
            <span class="dropdown-sort-span">{{'article_listing.published_date' |
                translate}}</span>
            <fa-icon aria-hidden="true" class="sort-icons"
                [icon]="['fas', isChevronUp[1] ? 'chevron-up' : 'chevron-down']"></fa-icon>
        </button>
        <button role="listitem" [attr.aria-label]="'article_listing.volume' |
        translate" class="dropdown-item d-flex justify-content-between align-items-center"
            (click)="toggleSort('volume',2)" (keyup.enter)="toggleSort('volume',2)"
            (keyup.space)="toggleSort('volume',2)" tabindex="0">
            <span class="dropdown-sort-span">{{'article_listing.volume' |
                translate}}</span>
            <fa-icon aria-hidden="true" class="sort-icons"
                [icon]="['fas', isChevronUp[2] ? 'chevron-up' : 'chevron-down']"></fa-icon>
        </button>
        <button role="listitem" [attr.aria-label]="'article_listing.issue' |
        translate" class="dropdown-item d-flex justify-content-between align-items-center"
            (click)="toggleSort('issue',3)" (keyup.enter)="toggleSort('issue',3)" (keyup.space)="toggleSort('issue',3)"
            tabindex="0">
            <span class="dropdown-sort-span">{{'article_listing.issue' |
                translate}}</span>
            <fa-icon aria-hidden="true" class="sort-icons"
                [icon]="['fas', isChevronUp[3] ? 'chevron-up' : 'chevron-down']"></fa-icon>
        </button>
        <button role="listitem" [attr.aria-label]="'article_listing.view_count' |
        translate" class="dropdown-item d-flex justify-content-between align-items-center"
            (click)="toggleSort('view_count',4)" (keyup.enter)="toggleSort('view_count',4)"
            (keyup.space)="toggleSort('view_count',4)" tabindex="0">
            <span class="dropdown-sort-span">{{'article_listing.view_count' |
                translate}}</span>
            <fa-icon aria-hidden="true" class="sort-icons"
                [icon]="['fas', isChevronUp[4] ? 'chevron-up' : 'chevron-down']"></fa-icon>
        </button>
        <button role="listitem" [attr.aria-label]="'article_listing.download_count' |
        translate" class="dropdown-item d-flex justify-content-between align-items-center"
            (click)="toggleSort('download_count',5)" (keyup.enter)="toggleSort('download_count',5)"
            (keyup.space)="toggleSort('download_count',5)" tabindex="0">
            <span class="dropdown-sort-span">{{'article_listing.download_count' |
                translate}}</span>
            <fa-icon aria-hidden="true" class="sort-icons"
                [icon]="['fas', isChevronUp[5] ? 'chevron-up' : 'chevron-down']"></fa-icon>
        </button>
    </div>
    <div class="form-control filter-buttons black-label keyword-filter d-flex">
        <input style="cursor:pointer;" type="checkbox" class="form-check-input" id="check5" name="option5"
            (keyup.enter)="specialIssueChange($event)"
            (change)="specialIssueChange($event)" value="special_issue" [checked]="special_issue">
        <label class="form-check-label justify-content pl-3" for="check5">
            {{'app_header.special_issues_jba' | translate}}
        </label>
    </div>

</div>